import {
  PeriodTypesAction,
  PeriodTypesState,
  updatePeriodTypesAction,
} from "store/types/periodTypes";

const initialState: PeriodTypesState = {
  teamsById: {},
};
export const periodTypes = (
  state = initialState,
  action: updatePeriodTypesAction
) => {
  switch (action.type) {
    case PeriodTypesAction.UPDATE_PERIOD_TYPES:
      return {
        ...state,
        teamsById: action.data,
      };
    default:
      return state;
  }
};
